<template>
  <div class="container">
    <div class="page-top">
      <div id="scene" style="position: absolute; width: 100vw; z-index: 1">
        <div data-depth="0.4" style="position: relative; margin-left: 13%; margin-top: 0px"><img style="width: 150px"
                                                                                                 src="@/assets/home/banner-left-1.png"/></div>
        <div data-depth="0.6" style="position: relative; margin-left: 20%; margin-top: 280px"><img style="width: 90px"
                                                                                                   src="@/assets/home/banner-left-2.png"/></div>
        <div data-depth="0.4" style="position: relative; margin-left: 77%"><img style="width: 150px" src="@/assets/home/banner-right-1.png"/>
        </div>
        <div data-depth="0.6" style="position: relative; margin-left: 76%; margin-top: 290px"><img style="width: 70px"
                                                                                                   src="@/assets/home/banner-right-2.png"/></div>
      </div>
      <div class="wrapper" data-depth="0" style="z-index: 2; position: relative" data-aos="fade-down" data-aos-delay="100">
        <div class="title effect-wrapper">探索软件新世界, 让您<span id="typed"></span><span class="cursor">&nbsp;</span>
        </div>
        <div class="tip">根据真实评论找到合适的软件和服务</div>
        <div class="search">
          <el-input class="input-key" placeholder="请输入产品名称、软件类别、公司名称搜索" v-model="keyword"></el-input>
          <el-button type="warning" round @click="$router.push({name:'soft-search',params:{keyword:keyword}})">
            立即搜索
          </el-button>
        </div>
      </div>
    </div>
    <div>
      <div class="wrapper" data-aos="zoom-in-up" data-aos-delay="300">
        <div class="title">为企业信息化提供信息和资源</div>
        <div class="com-wrapper">
          <div class="item">
            <div class="image">
              <el-image :src="require('@/assets/home/description.png')"></el-image>
            </div>
            <div class="item-title">产品介绍</div>
            <div class="desc">提供基本信息、用户画像、适用行业等快速了解产品详情</div>
            <div class="btn">了解更多...</div>
          </div>
          <div class="item">
            <div class="image">
              <el-image :src="require('@/assets/home/comment.png')"></el-image>
            </div>
            <div class="item-title">用户评论</div>
            <div class="desc">从超过 200 万条真实评论中获取见解，找到适合您的产品</div>
            <div class="btn">了解更多...</div>
          </div>
          <div class="item">
            <div class="image">
              <el-image :src="require('@/assets/home/compare.png')"></el-image>
            </div>
            <div class="item-title">深入比较</div>
            <div class="desc">缩小选择范围。比较和评估功能、价格和评级</div>
            <div class="btn">了解更多...</div>
          </div>
          <div class="item">
            <div class="image">
              <el-image :src="require('@/assets/home/research.png')"></el-image>
            </div>
            <div class="item-title">客观研究</div>
            <div class="desc">利用独立的数据驱动洞察从软件中获取最大的商业价值</div>
            <div class="btn">了解更多...</div>
          </div>
        </div>
      </div>
    </div>
    <div class="tongdian">
      <div class="wrapper" data-aos="zoom-in-up" data-aos-delay="300">
        <div class="title">企业信息化建设的痛点</div>
        <div class="item-wrapper">
          <div class="item">
            <div class="image">
              <el-image :src="require('@/assets/home/1.png')"></el-image>
            </div>
            <div class="item-title" style="letter-spacing: 1.5px">当企业选择成品软件时</div>
            <div class="desc" style="line-height: 1; font-size: 14px;">
              <p style="align-items: center; display: flex;align-items: flex-start; gap: 5px; margin: 0px; color: #384146; letter-spacing: 1px;">
                <img src="/img/icon/blue-dot.png" style="width: 12px;">
                <span>项目需求频繁变化,需要灵活调整团队</span>
              </p>
              <p style="align-items: center; display: flex;align-items: flex-start; gap: 5px; margin:20px 0 0; color: #384146; letter-spacing: 1px;">
                <img src="/img/icon/blue-dot.png" style="width: 12px;">
                <span>供需双方信息不对称,选型困难</span></p>
              <p style="align-items: center; display: flex;align-items: flex-start; gap: 5px; margin:20px 0 0; color: #384146; letter-spacing: 1px;">
                <img src="/img/icon/blue-dot.png" style="width: 12px;">
                <span>种类繁多价格不透明,售后服务不明确</span></p>
            </div>
            <a href="/store" target="_blank"><div class="btn">前往了解</div></a>
          </div>
          <div class="item">
            <div class="image">
              <el-image :src="require('@/assets/home/2.png')"></el-image>
            </div>
            <div class="item-title">当个性化需求定制开发时</div>
            <div class="desc" style="line-height: 1; font-size: 14px;">
              <p style="align-items: center; display: flex;align-items: flex-start; gap: 5px; margin: 0px; color: #384146; letter-spacing: 1px;">
                <img src="/img/icon/green-dot.png" style="width: 12px;">
                <span>传统开发模式需要较长的开发周期</span>
              </p>
              <p style="align-items: center; display: flex;align-items: flex-start; gap: 5px; margin:20px 0 0; color: #384146; letter-spacing: 1px;">
                <img src="/img/icon/green-dot.png" style="width: 12px;">
               <span>企业成本高需投入大量IT开发人员</span>
              </p>
              <p style="align-items: center; display: flex;align-items: flex-start; gap: 5px; margin:20px 0 0; color: #384146; letter-spacing: 1px;">
                <img src="/img/icon/green-dot.png" style="width: 12px;">
                <span>系统维护和升级需高成本和高风险</span>
              </p>
            </div>
            <a href="/platform" target="_blank"><div class="btn">前往了解</div></a>
          </div>
          <div class="item">
            <div class="image">
              <el-image :src="require('@/assets/home/3.png')"></el-image>
            </div>
            <div class="item-title">当企业项目缺乏人才时</div>
            <div class="desc" style="line-height: 1; font-size: 14px;">
              <p style="align-items: center; display: flex; align-items: flex-start; gap: 5px; margin: 0px; color: #384146; letter-spacing: 1px;">
                <img src="/img/icon/yellow-dot.png" style="width: 12px;">
                <span>企业在特定项目缺乏所需的专业人才</span>
              </p>
              <p style="align-items: center; display: flex; align-items: flex-start; gap: 5px; margin:20px 0 0; color: #384146; letter-spacing: 1px;">
                <img src="/img/icon/yellow-dot.png" style="width: 12px;">
                <span>传统招聘模式成本高时间长,预算有限</span>
              </p>
              <p style="align-items: center; display: flex; align-items: flex-start; gap: 5px; margin: 20px 0 0; color: #384146; letter-spacing: 1px;">
                <img src="/img/icon/yellow-dot.png" style="width: 12px;">
                <span>项目需求频繁变化,需要灵活调整团队</span>
              </p>
            </div>
            <a href="/crowd" target="_blank"><div class="btn">前往了解</div></a>
          </div>
        </div>
      </div>
    </div>
    <div class="soft-hot">
      <div class="wrapper" data-aos="zoom-in-up" data-aos-delay="300">
        <div class="title">热门软件分类</div>
        <div class="typeList">
          <div style="display: inline-grid; grid-template-columns: 20px auto 20px; align-items: center; width: 100%">
            <div @click="scrollLeft" style="width: 20px; height: 20px; line-height: 20px; color: #FF842E; font-weight: bold; cursor: pointer">
              <svg t="1731999752905" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3433" width="20" height="20"><path d="M299.52 521.728c-3.2768-13.9264 0.512-29.184 11.3664-40.0384l341.9136-341.9136c16.6912-16.6912 43.7248-16.6912 60.3136 0s16.6912 43.7248 0 60.3136L401.3056 512l311.9104 311.9104c16.6912 16.6912 16.6912 43.7248 0 60.3136s-43.7248 16.6912-60.3136 0l-342.016-341.9136c-5.632-5.632-9.6256-12.8-11.3664-20.5824z" fill="#FF842E" p-id="3434"></path></svg>
            </div>
            <div ref="scrollContainer" style="width: 100%; white-space: nowrap; overflow-x: auto; text-align: center">
              <div class="classify-item" v-for="item in typeList" :class="{'actived':item.id == typeId}"
                   @click="handleType(item)">{{ item.typeName }}
              </div>
            </div>
            <div @click="scrollRight" style="width: 20px; height: 20px; line-height: 20px; color: #FF842E; font-weight: bold; cursor: pointer">
              <svg t="1731999722169" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4259" width="20" height="20"><path d="M724.48 521.728c-1.8432 7.7824-5.7344 14.848-11.3664 20.48l-341.9136 342.016c-16.6912 16.6912-43.7248 16.6912-60.3136 0s-16.6912-43.7248 0-60.3136L622.6944 512 310.8864 200.0896c-16.6912-16.6912-16.6912-43.7248 0-60.3136 16.6912-16.6912 43.7248-16.6912 60.3136 0l341.9136 341.9136c10.8544 10.8544 14.6432 26.112 11.3664 40.0384z" fill="#FF842E" p-id="4260"></path></svg>
            </div>
          </div>
        </div>
        <div>
          <div class="classify" data-aos="fade-up-right" data-aos-delay="300">
            <div class="classify-content">
              <div class="classify-title">{{ type.typeName }}</div>
              <div class="classify-desc" style="-webkit-box-orient: vertical;">{{ type.summary }}</div>
            </div>
          </div>
          <div class="softList" data-aos="fade-up-left" data-aos-delay="300">
            <div class="softItem" v-for="item in dataList">
			  <a :href="'/store/detail/' + item.id.toString()" target="_blank">
				  <div class="soft-title">{{ item.name }}</div>
				  <div class="soft-desc" style="-webkit-box-orient: vertical;">{{ item.baseInfo }}</div>
				  <div class="btn">了解更多产品信息</div>
			  </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="anli">
      <div class="wrapper" data-aos="zoom-in-up" data-aos-delay="300">
        <div class="title">信息化客户案例</div>
        <div class="anli-wrapper">
          <div class="anli-item" v-for="(item,index) in anliList" v-if="index <= 3">
			  <a :href="'/case/detail/' + item.id.toString()" target="_blank">
				<el-image class="cover-image" :src="item.cover" fit="cover"></el-image>
				<div class="title" style="letter-spacing: 0">{{ item.title }}</div>
				<div class="abstrc" style="-webkit-box-orient: vertical;">{{ item.summary }}</div>
				<div class="bottom">
				  <div class="tag">{{ industryType[item.industryId] }}</div>
				  
				  <div class="link">查看详情
					<div class="icon-bg">
					  <i class="el-icon-right"></i>
					</div>
				  </div>
				</div>
              </a>
          </div>
        </div>
        <div class="btn">
          <el-button type="text"><a href="/case">了解更多客户案例</a></el-button>
        </div>
      </div>
    </div>
    <div class="zixun">
      <div class="wrapper" data-aos="zoom-in-up" data-aos-delay="300">
        <div class="title">热门资讯</div>
        <div class="zixun-msg">
          <div class="typeList" style="text-align: center">
            <div class="type-item" v-for="item in subType"
                 :class="{'active':item.id == topicType}"
                 @click="handleChange(item.id)">{{ item.typeName }}
            </div>
          </div>
          <div class="topic-wrapper">
            <div class="topicList">
              <div style="padding: 0px 20px 20px 0px;" data-aos="zoom-in-right" data-aos-delay="300">
                <!--                <div class="topicTitle" v-for="item in list" @click="toTopicDetail(item.id)">{{ item.title }}</div>-->
                <!--                <div class="more" @click="$router.push({name:'social',params:{typeId:topicType}})">更多&gt;&gt;</div>-->

                  <div v-for="item in list" class="topicItem" @mouseover="handleHover(item)"
                     :style="currentTopicId === item.id ? { background: 'rgba(255, 132, 68, 0.05)', padding: '20px', borderRadius: '20px', display:'block' } : {}"
                     style="color: rgb(64, 64, 64); font-size: 18px; font-weight: 500; word-break: break-all; text-overflow: ellipsis; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 1; overflow: hidden; margin-top: 10px;">
                    <div><a :href="'/social/detail/' + item.id.toString()" target="_blank">
                  {{ item.title }}

                  <div v-if="currentTopicId === item.id"
                       style="font-size: 16px; color: rgb(109, 109, 109); letter-spacing: 1px; margin-top: 5px; word-break: break-all; text-overflow: ellipsis; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 3; overflow: hidden;">
                    {{ item.description }}
                  </div>
                    </a></div>
                </div>

                <a href="/social"><div v-if="list && list.length > 0" class="more" style="margin-top: 20px">查看更多&gt;&gt;</div></a>
              </div>
            </div>
            <div class="image" data-aos="flip-right" data-aos-delay="300" style="width: 100%">
              <el-image :src="currentTopicSrc ? currentTopicSrc : require('@/assets/fengmian.jpeg')" fit="cover"></el-image>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="title">欢软合作伙伴</div>
      <div class="companys">
        <ul>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
        </ul>
        <ul>
          <li>
            <el-image src="/img/logo/building2.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building2.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building2.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building2.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building2.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building2.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building2.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building2.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building2.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building2.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building2.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building2.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
        </ul>
        <ul>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
          <li>
            <el-image src="/img/logo/building.png" style="width: 100%;" fit="scale-down"></el-image>
          </li>
        </ul>
      </div>
    </div>
    <!--    <div class="page-bottom">-->
    <!--      <div class="wrapper">-->
    <!--        <el-image style="width: 100%; height: 350px; border-radius: 50px; background: linear-gradient(to right, #FFF9F0, #F9FAFE)" :src="require('@/assets/home/bottom-line.png')" fit="cover"></el-image>-->
    <!--        <div id="scene2" style="position: absolute; width: 100vw; z-index: 1">-->
    <!--          <div data-depth="0.4" style="position: absolute; margin-top: -320px; margin-left: 15%"><img style="width: 150px"-->
    <!--                                                                                     src="@/assets/home/b-l-1.png"/>-->
    <!--          </div>-->
    <!--          <div data-depth="0.6" style="position: absolute; margin-top: -150px; margin-left: 13%"><img style="width: 70px"-->
    <!--              src="@/assets/home/b-l-2.png"/></div>-->
    <!--          <div data-depth="0.4" style="position: absolute; margin-top: -300px; margin-left: 55%"><img style="width: 70px" src="@/assets/home/b-r-1.png"/>-->
    <!--          </div>-->
    <!--          <div data-depth="0.6" style="position: absolute; margin-top: -210px; margin-left: 60%"><img style="width: 150px"-->
    <!--              src="@/assets/home/b-r-2.png"/></div>-->
    <!--        </div>-->
    <!--        <div class="content" style="z-index: 2">-->
    <!--          <div class="title" style="font-size: 32px; font-weight: 500; color: rgb(64, 64, 64)">免费加入欢软开始接单之旅</div>-->
    <!--          <div class="process">-->
    <!--            <span>填写表单并提交</span>-->
    <!--            <span><i class="iconfont icon-a-youjiantouzhixiangyoujiantou"></i></span>-->
    <!--            <span>客服对接基本信息</span>-->
    <!--            <span><i class="iconfont icon-a-youjiantouzhixiangyoujiantou"></i></span>-->
    <!--            <span>客服上传信息并确认</span>-->
    <!--            <span><i class="iconfont icon-a-youjiantouzhixiangyoujiantou"></i></span>-->
    <!--            <span>入驻成功</span>-->
    <!--          </div>-->
    <!--          <div class="input-wrapper">-->
    <!--            <el-input v-model="mobile" placeholder="请输入手机号码"></el-input>-->
    <!--            <el-button type="warning" class="btn">立即体验</el-button>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <Apply/>
  </div>
</template>

<script>
import {getList} from '@/api/anli/anli'
import {getTopicType, getTopicList, getHRCaseIndustryType} from '@/api/social/index'
import {getType, getSoftList} from '@/api/software/index'
import {getIsTrial, getToken} from '@/utils/auth'
import {toLogin} from '@/api/isLogin'
import Apply from "@/components/Apply.vue";
export default {
  components: {
    Apply,
  },
  data() {
    return {
      dataList: [],
      typeList: [],
      anliList: [],
      subType: [],
      list: [],
      topicType: '',
      keyword: '',
      mobile: '',
      type: {},
      typeId: '',
      page: 1,
      value: 4.5,
      industryType: {},
      currentTopicId: '',
      currentTopicSrc: ''
    }
  },
  methods: {
    handleHover(item) {
      this.currentTopicId = item.id;
      this.currentTopicSrc = item.descImages;
    },
    scrollLeft() {
      const container = this.$refs.scrollContainer;
      if (container) {
        container.scrollBy({ left: -200, behavior: "smooth" });
      }
    },
    scrollRight() {
      const container = this.$refs.scrollContainer;
      if (container) {
        container.scrollBy({ left: 200, behavior: "smooth" });
      }
    },
    async getData(id) {
      const res = await getSoftList({page: this.page, limit: 4, isSoftware: 1, typeId: id, conSub: 1})
      if (res.code === 0) {
        this.dataList = res.data.list
        this.total = res.data.total

      } else {
        this.$message.error(res.msg)
      }
    },
    async getAnliData() {
      const res = await getList()
      if (res.code === 0) {
        this.anliList = res.data.list

      } else {
        this.$message.error(res.msg)
      }
    },
    handleType(item) {
      this.typeId = item.id
      this.type = item
      this.getData(this.typeId)
	  console.log(item)
	  localStorage.setItem('softType', JSON.stringify({parentId:item.id,parentName:item.typeName}))
    },
    handleChange(id) {
      this.topicType = id
      this.getDatalist()
    },
    // 软件分类
    async getTypeList() {
      const res = await getType()
      if (res.code === 0) {
        this.typeList = res.data.list
        this.typeId = this.typeList[0].id
        this.type = this.typeList[0]
        this.getData(this.typeId)
		localStorage.setItem('softType', JSON.stringify({parentId:this.typeList[0].id,parentName:this.typeList[0].typeName}))
      } else {
        this.$message.error(res.msg)
      }
    },
    // 话题分类
    async getTypeData() {
      const res = await getTopicType()
      if (res.code === 0) {
        res.data.list.forEach((item) => {
          if (item.typeName == '热门资讯') {
            this.subType = item.children
          }
        })

        this.topicType = this.subType[0].id
        this.getDatalist()
      } else {
        this.$message.error(res.msg)
      }
    },
    // 案例分类
    async getHRCaseIndustryType() {
      const res = await getHRCaseIndustryType()
      if (res.code === 0) {
        for (var i = 0; i < res.data[0].dataList.length; i++) {
          this.industryType[res.data[0].dataList[i].dictValue] = res.data[0].dataList[i].dictLabel
        }
      }
    },
    async getDatalist() {
      const res = await getTopicList({page: 1, limit: 7, typeId: this.topicType})
      if (res.code === 0) {
        this.list = res.data.list
        if (res.data.list && res.data.list.length > 0) {
          this.currentTopicId = res.data.list[0].id
          this.currentTopicSrc = res.data.list[0].descImages
        }
      } else {
        this.$message.error(res.msg)
      }
    },
    toSoftDetail(id) {
      this.$router.push({name: 'soft-detail', params: {id: id}})
    },
    toDetail(id) {
      // if (getToken()) {
      this.$router.push({name: 'anli-detail', params: {id: id}})
      /* } else {
        toLogin(this)
      } */
    },
    toTopicDetail(id) {
      this.$router.push({path: '/social/detail/' + id})
    },
    daziji() {
      const typedSpan = document.getElementById("typed")
      const totype = ["省心省力！", "高效便捷！", "轻松自在！"]

      const delayTyping_char = 200;
      const delayErasing_text = 100;
      const delayTyping_text = 1000;

      let totypeIndex = 0;
      let charIndex = 0;

      function typeText() {
        if (charIndex < totype[totypeIndex].length) {
          typedSpan.textContent += totype[totypeIndex].charAt(charIndex);
          charIndex++;
          setTimeout(typeText, delayTyping_char);
        } else {
          setTimeout(eraseText, delayTyping_text);
        }
      }

      function eraseText() {
        if (charIndex > 0) {
          typedSpan.textContent = totype[totypeIndex].substring(0, charIndex - 1);
          charIndex = charIndex - 1;
          setTimeout(eraseText, delayErasing_text);
        } else {
          totypeIndex++;

          if (totypeIndex >= totype.length)
            totypeIndex = 0;
          setTimeout(typeText, delayTyping_text);
        }
      }

      if (totype[totypeIndex].length) setTimeout(typeText, delayTyping_text);
    }
  },
  mounted() {

    var scene = document.getElementById('scene');
    var parallaxInstance = new Parallax(scene, {
      relativeInput: false
    });
    this.getTypeList()
    this.getAnliData()
    this.getTypeData()
    this.getHRCaseIndustryType()
    this.daziji()




  }

}
</script>

<style lang="scss" scoped>
.container {
  & > div:not(:first-child) {
    margin-top: 100px;
  }

  .wrapper {
    max-width: 1400px;
    width: 80vw;
    margin: 0 auto;
  }

  .title {
    text-align: center;
    font-size: 30px;
    font-weight: 800;
    color: rgb(56, 56, 56);
	  letter-spacing: 5px;
  }

  .page-top {
    background-image: url('../../assets/home/banner.png');
    background-position: center; /* 背景图居中 */
    background-size: cover; /* 自动填充裁切 */
    background-repeat: no-repeat; /* 不重复 */
    padding: 100px 0;
    height: 350px;

    .wrapper {
      margin: 50px auto 20px;
    }

    .title {
      font-size: 40px;
    }

    .tip {
      text-align: center;
      color: #4B4B4B;
      margin: 20px 0;
      margin-top: 30px;
      font-size: 20px;
    }

    .search {
      position: relative;
      width: 60%;
      margin: auto;
      margin-top: 40px;

      /deep/ .el-input__inner {
        border-radius: 20px;
        padding-left: 30px;
        border: none;
      }

      .el-button {
        position: absolute;
        right: 0;
        bottom: 0;
        background-color: #FF842E;
        width: 120px;
      }
    }
  }

  .tongdian {
    .item-wrapper {
      margin-top: 30px;
      display: flex;

      .item {
        transition: transform 0.3s ease;
        flex: 0 0 32%;
        margin-right: 1%;
        background-color: #F6F9FF;
        border-radius: 15px;
        padding: 30px;
        box-sizing: border-box;
        position: relative;

        .image {
          margin-bottom: 20px;

          .el-image {
            width: 60px;
            height: 60px;
            border-radius: 8px;
          }
        }

        .item-title {
          color: #404040;
          font-size: 20px;
          font-weight: 800;
          margin-bottom: 20px;
        }

        .desc {
          color: #787777;
          font-size: 16px;
          margin-bottom: 80px;
          white-space:pre-line;
          line-height: 1.65;
        }

        .btn {
          color: #FF842E;
          border: 1px solid #FF842E;
          border-radius: 20px;
          width: calc(100% - 60px);
          text-align: center;
          cursor: pointer;
          position: absolute;
          left: 30px;
          bottom: 50px;
          transition: all 0.3s;
        }
      }
      .item:hover {
        transform: translateY(-20px);
        .btn {
          width: calc(100% - 60px);
          color: #FFF;
          background: #FF842E;
          height: 40px;
          line-height: 40px;
          border-radius: 10px;
        }
      }
    }
  }

  .soft-hot {
    background-color: #F6F9FF;
    padding: 30px 0;

    .typeList {
      margin: 40px 0px;
      width: 100%;
      overflow-x: auto;
      margin-bottom: 10px;
      .classify-item {
        display: inline-block;
        margin: 0 15px;
        font-size: 15px;
        color: #75777D;
        cursor: pointer;

        &:last-child {
          margin: 0;
        }

        &.actived {
          color: #FF8632;
          font-weight: 600;
        }
      }
    }

    .classify-content {
      background-image: url('../../assets/home/hotSoft.png');
      background-size: 100% auto;
      background-repeat: no-repeat;
      height: 350px;
      padding: 0 30px;
      background-position: center bottom;
    }

    .classify {
      background: linear-gradient(#FFFEFC, #ffffff);
      width: 350px;
      height: 350px;
      border-radius: 15px;
      padding-top: 30px;
      display: inline-block;
      margin-right: 10px;
      vertical-align: top;
      .classify-title {
        color: #404040;
        font-size: 22px;
        font-weight: 800;
      }

      .classify-desc {
        color: #6D6D6D;
        font-size: 16px;
        margin: 8px 0;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        white-space: normal;
      }
    }

    .softList {
      width: calc(100% - 360px);
      height: 380px;
      padding: 25px 30px;
      box-sizing: border-box;
      background: linear-gradient(#FFFEFC, #ffffff);
      border-radius: 15px;
      display: inline-flex;
      flex-wrap: wrap;

      .softItem {
        flex: 0 0 47%;
        margin-bottom: 20px;
		cursor: pointer;
        &:nth-child(odd) {
          margin-right: 6%;
        }

        .soft-title {
          font-size: 18px;
          font-weight: 800;
        }

        .soft-desc {
          color: #6D6D6D;
          font-size: 16px;
          height: 48px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          text-overflow: ellipsis;
          white-space: normal;
          margin: 15px 0;
        }

        .btn {
          color: #FF842E;
          cursor: pointer;
        }
      }
    }
  }

  .com-wrapper {
    margin-top: 40px;
    display: flex;

    .item {
      transition: margin-top .3s;
      flex: 0 0 25%;
      text-align: center;
      padding: 10px 20px;
      box-sizing: border-box;
      border-left: 1px solid #E2E5EC;
      position: relative;

      &:last-child {
        border-right: 1px solid #E2E5EC;

        &::after {
          content: '';
          position: absolute;
          right: -1px;
          bottom: 100px;
          background-color: #FF842E;
          height: 20px;
          width: 2px;
        }
      }

      &::before {
        content: '';
        position: absolute;
        left: -1px;
        bottom: 100px;
        background-color: #FF842E;
        height: 20px;
        width: 2px;
      }

      .image {
        .el-image {
          width: 65px;
          height: 65px;
          border-radius: 10px;
        }
      }

      .item-title {
        font-size: 20px;
        font-weight: 800;
        margin: 10px;
      }

      .desc {
        color: #606060;
        height: 80px;
      }

      .btn {
        margin-top: 20px;
        color: #FF842E;
        cursor: pointer;
      }
    }
    .item:hover {
      margin-top: -20px;
    }
  }

  .anli, .zixun {
    max-width: 1400px;
    width: 80vw;
    box-sizing: border-box;
    padding: 30px;
    padding-bottom: 80px;
    background-color: #F6F9FF;
    border-radius: 30px;
    margin: 50px auto;

    .wrapper {
      width: 100%;
    }
  }

  .anli {
    .anli-wrapper {
      margin: 50px 0;
      display: grid;
      //flex-wrap: wrap;
      width: calc(100% - 45px);
      grid-template-columns: repeat(4, 25%);
      gap: 15px;
    }

    .btn {
      text-align: center;
      margin-top: 50px;

      .el-button {
        color: #FF842E;
      }
    }

    .anli-item {
      transition: transform 0.3s ease;
      //flex: 0 0 31.5%;
      background-color: #fff;
      //display: inline-block;
      border-radius: 10px;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.01), 0 6px 10px 0 rgba(0, 0, 0, 0.02);
      //margin: 10px 15px 0 0;
      font-size: 14px;
      position: relative;
      padding-bottom: 70px;

      .cover-image {
        width: 100%;
        height: 220px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }

      .title {
        font-size: 18px;
        font-weight: 800;
        width: 90%;
        margin: 10px auto;
        margin-bottom: 15px;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .abstrc {
        color: rgb(109, 109, 109);
        letter-spacing: 1px;
        width: 90%;
        margin: 0 auto;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        white-space: normal;
      }

      .bottom {
        width: 90%;
        position: absolute;
        bottom: 25px;
        left: 15px;
        .tag {
          background-color: #DBF9E5;
          color: #4BA162;
          padding: 3px 12px;
          border-radius: 5px;
          font-size: 12px;
          width: fit-content;
          display: inline-block;
        }

        .link {
          display: inline-block;
          float: right;
          cursor: pointer;

          .icon-bg {
            background-color: #FF842E;
            border-radius: 50%;
            width: 18px;
            height: 18px;
            display: inline-block;
            line-height: 18px;
            .el-icon-right {
              color: #fff;
            }
          }
        }
      }
    }
    .anli-item:hover {
      transform: translateY(-20px);
    }
  }

  .zixun .zixun-msg {
    position: relative;
    min-height: 230px;

    .typeList {
      margin: 20px;
      margin-top: 50px;
      .type-item {
        display: inline-block;
        cursor: pointer;
        font-size: 16px;
        border: 1px solid rgb(106, 106, 106);
        width: 180px;
        height: 40px;
        line-height: 40px;
        border-radius: 20px;
        text-align: center;
        margin: 0 30px;
        color: rgb(113, 113, 113);
        &.active {
          background-color: #FF8632;
          color: #FFFFFF;
          border: 1px solid rgba(106, 106, 106, 0);
        }
      }
    }
	.topic-wrapper{
		background-color: #FFFFFF; 
		padding: 8px 8px 5px 30px; 
		border-radius: 40px; 
		display: inline-grid; 
		grid-template-columns: auto 45%;
	}
    .topicList {
      .topicItem {
        padding: 0 20px 0 20px;
        //transition: all .3s;
        cursor: pointer;
      }
      .topicItem:hover {
        padding: 20px;
        background: rgba(255, 132, 68, 0.05);
        border-radius: 20px;
      }
      .topicTitle {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 16px;
        margin-top: 8px;
        cursor: pointer;
      }

      .more {
        margin-top: 10px;
        font-size: 15px;
        cursor: pointer;
        color: #FF8632;
        margin-left: 20px;
      }
    }

    .image {
      //position: relative;
      //top: 90px;
      //right: 10px;
      //width: 280px;

      .el-image {
        width: 100%;
        height: 375px;
        border-radius: 30px;
      }
    }
  }

  .page-bottom {
    width: 100%;
    margin: 50px 0;
    .wrapper {
      position: relative;
      max-width: 1400px
    }

    .content {
      width: 50%;
      position: absolute;
      top: 70px;
      left: 50%;
      // right: 0;
      margin-left: -25%;
      text-align: center;

      .title {
        font-size: 28px;
        font-weight: bold;
        margin: 20px 0;
        text-align: center;
      }

      .process {
        color: #454851;
        font-size: 14px;
        margin-bottom: 20px;
        margin-top: 0;
      }

      .iconfont {
        color: #BEBFC0;
        margin: 0 10px;
      }

      .input-wrapper {
        position: relative;
        max-width: 450px;
        margin: auto;

        .el-input {
          /deep/ .el-input__inner {
            border-radius: 20px;
            padding-left: 25px;
          }

        }

        /deep/ .el-input.is-active .el-input__inner,
        /deep/ .el-input__inner:focus {
          border-color: #C0C4CC;
        }

        .el-button--warning {
          background-color: #FF842E;
        }
      }

      .btn {
        position: absolute;
        bottom: 0;
        right: 0;
        border-radius: 20px;
        padding: 12px 32px;
      }

    }
  }

  .companys {
    width: 1400px;
    margin: 30px auto;
    overflow: hidden; /* 确保内容不会超出显示区域 */
  }

  .companys ul {
    display: flex; /* 用于水平排列列表项 */
    width: max-content; /* 确保内容宽度自适应 */
    padding-left: 0 !important;
    animation-timing-function: linear; /* 动画匀速滚动 */
    animation-iteration-count: infinite; /* 动画无限循环 */
  }

  .companys ul li {
    width: 250px;
    height: 100px;
    margin-top: 20px;
    list-style: none;
    border-radius: 10px;
    background: #F7F9FF;
    display: inline-flex;
    margin: 0 10px;
  }

  /* 第一行动画，速度快 */
  .companys ul:nth-child(1) {
    animation-name: scroll-back-and-forth-fast;
    animation-duration: 60s;
  }

  /* 第二行动画，速度慢 */
  .companys ul:nth-child(2) {
    animation-name: scroll-back-and-forth-slow;
    animation-duration: 60s;
  }

  /* 第三行动画，速度快 */
  .companys ul:nth-child(3) {
    animation-name: scroll-back-and-forth-fast;
    animation-duration: 60s;
  }

  /* 定义从右到左再到右的快速动画 */
  @keyframes scroll-back-and-forth-fast {
    0% {
      transform: translateX(0%); /* 初始位置在最右端 */
    }
    25% {
      transform: translateX(-50%); /* 滚动到最左端 */
    }
    50% {
      transform: translateX(-100%); /* 滚动到最左端 */
    }
    75% {
      transform: translateX(-50%); /* 滚动到最左端 */
    }
    100% {
      transform: translateX(0%); /* 返回到最右端 */
    }
  }

  /* 定义从右到左再到右的慢速动画 */
  @keyframes scroll-back-and-forth-slow {
    0% {
      transform: translateX(-100%); /* 初始位置在最右端 */
    }
    25% {
      transform: translateX(-50%); /* 滚动到最左端 */
    }
    50% {
      transform: translateX(0%); /* 滚动到最左端 */
    }
    75% {
      transform: translateX(-50%); /* 滚动到最左端 */
    }
    100% {
      transform: translateX(-100%); /* 返回到最右端 */
    }
  }


}

@media (min-width: 1025px) and (max-width: 1260px) {
  .container {
    .page-bottom {
      .content {
        top: 50px;

        .title {
          font-size: 24px;
          margin: 20px 0;
        }

      }
    }
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .container {
	  .zixun {
	  	.zixun-msg {
	  	  position: relative;
	  	  min-height: 230px;
	  	
	  	  .typeList {
	  		display: flex;
	  		.type-item {
	  		  // width: 80px;
	  		  flex: 1;
	  		  margin: 0;
	  		  margin-right: 25px;
	  		  &:last-child{
	  			  margin-right: 0;
	  		  }
	  		}
	  	  }
	  	}
	  }
    .page-bottom {
      .content {
        top: 15px;

        .title {
          font-size: 24px;
          margin: 20px 0;
        }

      }
    }
  }

}

@media screen and (max-width: 767px) {
  .container {
	  .wrapper{
		  width: calc(100vw - 20px);
	  }
	  .page-top {
	    padding: 50px 0;

	  
	    #scene{
			div:first-child{
				margin-left: 0 !important;
				img{
					width: 80px !important;
				}
			}
			div:nth-child(2){
				margin-left: 20px !important;
				img{
					width: 70px !important;
				}
			}
			div:nth-child(3){
				left: unset !important;
				right: 0 !important;
				margin-right: 10px !important;
				img{
					width: 80px !important;
				}
			}
			div:last-child{
				right: 0 !important;
				margin-right: 25px !important;
				img{
					width: 50px !important;
				}
			}
		}
	    .search {
	      width: 95%;
	      /deep/ .el-input__inner {
	        padding-left: 20px;
	      }
	      .el-button {
	        width: 100px;
	      }
	    }
	  }
	  .com-wrapper {
	    margin-top: 40px;
	    display: flex;
		flex-wrap: wrap;
	    .item {
	      transition: margin-top .3s;
	      flex: 0 0 50%;
		  margin: 20px 0;
	      text-align: center;
	      padding: 10px 20px;
	      box-sizing: border-box;
	      border-left: 1px solid #E2E5EC;
	      position: relative;
	  
	      &:nth-child(2n) {
	        border-right: 1px solid #E2E5EC;
	        &::after {
	          content: '';
	          position: absolute;
	          right: -1px;
	          bottom: 100px;
	          background-color: #FF842E;
	          height: 20px;
	          width: 2px;
	        }
	      }
	    }

	  }
	  .tongdian {
	    .item-wrapper {
	      display: block;
	      .item {
	        width: 100%;
	        margin-top: 20px;
		  }
	    }
	  }
	  .soft-hot {
	    background-color: #F6F9FF;
	    padding: 30px 0;
	  
	    .classify-content {
	      background-size: 50% auto;
	      height: 140px;
	      background-position: right bottom;
	    }
	  
	    .classify {
	      width: 100%;
	      height: 140px;
	      display: block;
	      margin-right: 0;
	      .classify-desc {
			width: 50%;
	        -webkit-line-clamp: 3;
	      }
	    }
	  
	    .softList {
	      width: 100%;
		  margin-top: 20px;
	      padding: 25px 20px;
	      .softItem {
	        .soft-desc {
	          -webkit-line-clamp: 3;
	          
	        }

	      }
	    }
	  }
	  .anli {
		width: calc(100vw - 20px);
		padding-bottom: 30px;
	    .anli-wrapper {
	      margin: 30px 0;
	      display: block;
	      width: 100%;
		  .title{
			  font-size: 24px;
		  }
	    }
	    .anli-item {
			display: block;
			width: 100%;
			margin-bottom: 20px;
		}
	}
	.zixun {
		width: calc(100vw - 20px);
		padding: 30px 10px;
		.zixun-msg {
		  position: relative;
		  min-height: 230px;
		
		  .typeList {
			display: flex;
			.type-item {
			  // width: 80px;
			  flex: 1;
			  height: 30px;
			  line-height: 30px;
			  margin: 0;
			  margin-right: 15px;
			  &:last-child{
				  margin-right: 0;
			  }
			}
		  }
		  .topic-wrapper{
		  	display: block;
			padding: 8px 8px 5px 15px !important;
			margin: 30px 0;
			.el-image{
				height: 245px;
			}
		  }
		}
		
	}
    .page-bottom {
      .content {
        top: 15px;

        .title {
          font-size: 18px;
          margin: 10px 0;
        }

        .process {
          margin-bottom: 10px;
        }

        .input-wrapper {
          position: relative;

          .el-input {
            /deep/ .el-input__inner {
              font-size: 12px;
              height: 30px;
              line-height: 30px;
            }
          }
        }

        .btn {
          position: absolute;
          bottom: 0;
          right: 0;
          border-radius: 20px;
          padding: 0 32px;
          height: 30px;
          line-height: 30px;
        }
      }
    }
  }

}

</style>

<style>
.wrapper {
//height: 100vh; width: auto;
//display: flex; justify-content: center;
  align-items: center;
}

.effect-wrapper {
  text-align: center;
  font-weight: normal;
}

#typed {
  font-weight: bold;
  color: #FF842E;
  margin-left: 5px;
  font-size: 50px;
}

.cursor {
  display: inline-block;
  width: 3px;
  margin-left: 3px;
  animation: blinker 800ms infinite;
}

.cursor.typing-true {
  animation: none;
}

@keyframes blinker {
  0% {
    background-color: #FF842E;
  }
  50% {
    background-color: transparent;
  }
  100% {
    background-color: #FF842E;
  }
}
a {
  all: unset;
}
</style>

